import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatCurrency'
})
export class FormatCurrencyPipe implements PipeTransform {

  transform(value: any): string {
    // Check if the value is a valid number
    const validAmount = !isNaN(value) && value !== null && value !== '';
    
    // If it's a valid number, format with ₹ symbol
    if (validAmount) {
      return `₹ ${parseFloat(value).toFixed(2)}`;
    } else {
      // If not a valid number, return 0
      return '₹ 0.00';
    }
  }
}
